import React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Fade } from 'react-reveal'
import StepWizard from "react-step-wizard"
import NavQuiz from '../../../components/Quiz/NavQuiz'
import Step0 from '../../../components/Quiz/Steps/Step0'
import Step1 from '../../../components/Quiz/Steps/Step1'
import Step2 from '../../../components/Quiz/Steps/Step2'
import Step3 from '../../../components/Quiz/Steps/Step3'
import WebsiteTab from '../../../components/WebsiteTab'
import { fetchQuiz } from '../../../features/quiz/quizSlice'
import { selectUserInfo } from '../../../features/users/userInfoSlice'
import { fetchWebsites, selectAll } from '../../../features/websites/websitesSlice'

function Quiz() {
  const dispatch = useDispatch();
  const websites = useSelector(selectAll)
  const loadingQuiz = useSelector(state => state.quiz.loading)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)
  const userInfoContext = useSelector(selectUserInfo)

  useEffect(() => {
    if (websites.length > 0) return
    dispatch(fetchWebsites({ company_id: userInfoContext?.user?.company_id }))
  }, [userInfoContext?.user?.company_id])

  useEffect(() => {
    dispatch(fetchQuiz({ website_id: activeWebsite?.id }))
  }, [activeWebsite?.id])

  return (
    <div className="relative">
      {loadingQuiz && <Fade>
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-filter backdrop-blur-sm [@supports(backdrop-filter:blur(10px))]:bg-black/30 flex items-center justify-center">
          <div className="flex flex-col items-center justify-center">
            <div className="w-24 h-24 border-l-4 border-general-teal/40 rounded-full animate-spin"></div>
            <p className="text-white font-semibold text-lg">Chargement de vos réponses...</p>
          </div>
        </div>
      </Fade>}
      <div className="mt-4 max-w-lg mx-auto">
        <WebsiteTab />
      </div>
      {!loadingQuiz && <StepWizard
        className='max-w-md md:max-w-7xl w-full mx-auto md:my-0 rounded-xl overflow-hidden quiz-step'
        nav={<NavQuiz />}
      >
        <Step0 />
        <Step1 />
        <Step2 />
        <Step3 />
      </StepWizard>}
    </div>
  )
}

export default Quiz